/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  CreateAutomationMutationRequest,
  CreateAutomationMutationResponse,
  CreateAutomation400,
} from '../types/CreateAutomation'

function getCreateAutomationUrl() {
  const res = {
    method: 'POST',
    url: `/api/v1/automations/automations/` as const,
  }
  return res
}

/**
 * @description Override create to handle both regular JSON and multipart form data
 * @summary Create an automation
 * {@link /api/v1/automations/automations/}
 */
export async function createAutomation(
  data: CreateAutomationMutationRequest,
  config: Partial<RequestConfig<CreateAutomationMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    CreateAutomationMutationResponse,
    ResponseErrorConfig<CreateAutomation400>,
    CreateAutomationMutationRequest
  >({
    method: 'POST',
    url: getCreateAutomationUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
